import { mapValues } from 'lodash';
import { format, isBefore, isAfter, subYears } from 'date-fns';
import { errors } from '../content/content';

const rawValidators = {
  isPercentage: (p: string) => (m: any) => Number(m[p]) < 100,
  isRequired: (p: string) => (m: any) => !!m[p],
  isNumber: (p: string) => (m: any) => (m[p] ? (m[p] && (!isNaN(Number(m[p])) && Number(m[p]) >= 0)) : true),
  isInteger: (p: string) => (m: any) => (m[p] && (!isNaN(Number(m[p])) && Number(m[p]) % 1 === 0)),
  isMoreThan0: (p: string) => (m: any) => Number(m[p]) > 0,
  isFiftyFiveOrMore: (p: string) => (m: any) => Number(m[p]) >= 55,
  isEighteenOrMore: (p: string) => (m: any) => Number(m[p]) >= 18,
  isEightyOrLess: (p: string) => (m: any) => Number(m[p]) <= 80,
  isOneHundredOrLess: (p: string) => (m: any) => Number(m[p]) <= 100,
  isLessThanOneMillion: (p: string) => (m: any) => (m[p] ? Number(m[p]) < 1000000 : true),
  isOver18: (p: string) => (m: any) => isBefore(format(m[p]), subYears(new Date(), 18)),
  isAfter1900: (p: string) => (m: any) => isAfter(format(m[p]), new Date(1899, 11, 31)),
  isInThePast: (p: string) => (m: any) => isBefore(format(m[p]), new Date()),
  isDateValid: (p: string) => (m: any) => {
    if (m[p]) {
      const splitDate = m[p].split('/');
      const day = Number(splitDate[2]);
      const month = Number(splitDate[1]);
      const year = Number(splitDate[0]);
      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (String(year).length !== 4) {
        return false;
      }

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
      }

      if (month === 0 || month > 12) {
        return false;
      }

      return day > 0 && day <= monthLength[month - 1];
    }

    return false;
  },
};

const buildValidator = (prop: string, shouldValidate?: (model: any) => boolean, error?: string) =>
  (validator: (model: any) => boolean) => [
    (model: any) => (!shouldValidate || shouldValidate(model) ? validator(model) : true),
    { [prop]: error },
  ];

const validators = mapValues(rawValidators, (value: (p: string) => (m: any) => boolean, key: string) =>
  (prop: string, shouldValidate?: (model: any) => boolean, error = errors[key]) =>
    buildValidator(prop, shouldValidate, error)(value(prop)));

export default validators;



// WEBPACK FOOTER //
// ./src/utilities/validators.ts